import LaunchesFeed from './LaunchesFeed';

export default LaunchesFeed;
